<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup lang="ts">
    import {provide} from 'vue';
    import {useAsyncData} from '#app';
    import {storeToRefs, useAuth, useCanonicalURL, useHostSettings, useHTMLAttrsLang, usePrismicClient, usePrismicPreviewScript} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {usePageCache} from '@malt/utils';
    import {HOST_SETTINGS, PRISMIC_CLIENT} from '~/keys';

    const enablePageCache = useFeatureFlag('enable-page-cache');

    const authStore = useAuth();
    const {loggedIn} = storeToRefs(authStore);

    usePrismicPreviewScript();
    useHTMLAttrsLang();
    useCanonicalURL();

    const client = usePrismicClient();
    provide(PRISMIC_CLIENT, client);

    const {data: hostSettings} = await useAsyncData('host-settings', () => useHostSettings());
    provide(HOST_SETTINGS, hostSettings.value!);

    if (!loggedIn.value && enablePageCache.value) {
        usePageCache();
    }
</script>

<style lang="scss">
    /* stylelint-disable-next-line selector-max-id -- Nuxt root */
    #__nuxt {
        height: 100vh;
    }
</style>
